import { render, staticRenderFns } from "./application_announcement_writing.vue?vue&type=template&id=51577da2&scoped=true"
import script from "./application_announcement_writing.vue?vue&type=script&lang=js"
export * from "./application_announcement_writing.vue?vue&type=script&lang=js"
import style0 from "./application_announcement_writing.vue?vue&type=style&index=0&id=51577da2&prod&lang=css"
import style1 from "./application_announcement_writing.vue?vue&type=style&index=1&id=51577da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51577da2",
  null
  
)

export default component.exports